import React, { useState, useEffect } from "react";
import BarGraph from "./BarGraph";
import axios from "axios";
import Baseurl from "../../../Baseurl";
import { Spinner } from "react-bootstrap";
import swal from "sweetalert";
export default function CategoryAnalytics() {
  const [category, setCategory] = useState("Go_Taxi");
  const [type, setType] = useState("ToDay");
  const [analyticData, setAnalyticData] = useState([]);
  const [fiveYearsData, setFiveYearsData] = useState([]);
  const [months, setMonths] = useState("");
  const [spinner, setSpinner] = useState(false);
  const [lastYear, setLastYear] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [tillDate, setTillDate] = useState("");
  const currentDate = new Date().toISOString().split('T')[0];
  const categoryArray = [
    "Go_Taxi",
    "Go_Movers",
    "Go_Food",
    "Go_Health",
    "Go_Airport",
    "Go_Rentals",
  ];
  const typeArray = ["ToDay","Yesterday", "Weekly","This Month","Last Month", "Monthly","Yearly", "Custom Dates","Last Years"];
  const monthArray = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  
  function getMonthAnalyticsData(month) {
    setSpinner(true)
    let currentDate = new Date();
    let currentYear = currentDate.getFullYear();
    axios
      .get(
        `${
          Baseurl.baseurl
        }/go-admin/get-month-analytic/${category}/${monthArray.indexOf(
          month
        )}/${currentYear}`
      )
      .then((res) => {
        setSpinner(false)
        if (res.data.status) {
          setAnalyticData(res.data);
        } else {
          setAnalyticData([]);
          swal("Oops", res.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {});
  }
  function getDailyAnalyticData(){
    setSpinner(true)
    let currentDate = new Date();
    let currentYear = currentDate.getFullYear();
    let date=currentDate.getDate()
    let month=currentDate.getMonth()
    axios
      .get(
        `${
          Baseurl.baseurl
        }/go-admin/get-daily-analytic/${category}/${date}/${month}/${currentYear}`
      )
      .then((res) => {
        setSpinner(false)
        if (res.data.status) {
          setAnalyticData(res.data);
        } else {
          setAnalyticData([]);
          swal("Oops", res.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {});
  }
  function getYearlyAnalyticData(sub,year){
    setSpinner(true)
    let currentDate = new Date();
    let currentYear = currentDate.getFullYear();
    axios
      .get(
        `${
          Baseurl.baseurl
        }/go-admin/get-yearly-analytic/${category}/${sub==="this"?currentYear:year}`
      )
      .then((res) => {
        setSpinner(false)
        if (res.data.status) {
          setAnalyticData(res.data);
        } else {
          setAnalyticData([]);
          swal("Oops", res.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {}); 
  }
  function getWeeklyAnalyticData(){
    setSpinner(true)
    let currentDate = new Date();
    let currentYear = currentDate.getFullYear();
    let date=currentDate.getDate()
    let month=currentDate.getMonth()
    axios
      .get(
        `${
          Baseurl.baseurl
        }/go-admin/get-weekly-analytic/${category}/${date}/${month}/${currentYear}`
      )
      .then((res) => {
        setSpinner(false)
        if (res.data.status) {
          setAnalyticData(res.data);
        } else {
          setAnalyticData([]);
          swal("Oops", res.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {}); 
  }
  function getCustomDateAnalytics(val){
    setSpinner(true)
    axios
    .get(`${Baseurl.baseurl}/go-admin/get-custom-analytic/${category}/${startDate.split('-')[2]}/${startDate.split('-')[1]-1}/${startDate.split('-')[0]}/${val.split('-')[2]}/${val.split('-')[1]-1}/${val.split('-')[0]}`)
    .then((res) => {
      setSpinner(false)
      if (res.data.status) {
        setAnalyticData(res.data);
      } else {
        setAnalyticData([]);
      }
    })
    .catch((err) => {});
  } 
  useEffect(()=>{
    getDailyAnalyticData()
  },[])
  function getYesterdayAnalyticData(){
    setSpinner(true)
    let currentDate = new Date();
    let yesterdayDate = new Date(currentDate);
    yesterdayDate.setDate(currentDate.getDate() - 1);
    let currentYear = yesterdayDate.getFullYear();
    let date=yesterdayDate.getDate()
    let month=yesterdayDate.getMonth()
    axios
      .get(
        `${
          Baseurl.baseurl
        }/go-admin/get-daily-analytic/${category}/${date}/${month}/${currentYear}`
      )
      .then((res) => {
        setSpinner(false)
        if (res.data.status) {
          setAnalyticData(res.data);
        } else {
          setAnalyticData([]);
          swal("Oops", res.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {});
  }
  function getLastMonthAnalyticData(){
    setSpinner(true)
    let currentDate = new Date();
    let currentYear = currentDate.getFullYear();
    let month=currentDate.getMonth()
    axios
      .get(
        `${
          Baseurl.baseurl
        }/go-admin/get-month-analytic/${category}/${month-1}/${currentYear}`
      )
      .then((res) => {
        setSpinner(false)
        if (res.data.status) {
          setAnalyticData(res.data);
        } else {
          setAnalyticData([]);
          swal("Oops", res.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {});
  }
  function getThisMonthAnalyticData(){
    setSpinner(true)
    let currentDate = new Date();
    let currentYear = currentDate.getFullYear();
    let month=currentDate.getMonth()
    axios
      .get(
        `${
          Baseurl.baseurl
        }/go-admin/get-month-analytic/${category}/${month}/${currentYear}`
      )
      .then((res) => {
        setSpinner(false)
        if (res.data.status) {
          setAnalyticData(res.data);
        } else {
          setAnalyticData([]);
          swal("Oops", res.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {});
  }
  function getCategoryChangeWise(){
    setType(type);
    if(type==="ToDay"){
      getDailyAnalyticData()
    }else
    if(type==="Yesterday"){
      getYesterdayAnalyticData()
    }else
    if(type==="Last Month"){
      getLastMonthAnalyticData()
    }else
    if(type==="This Month"){
      getThisMonthAnalyticData()
    }else
    if(type==="Yearly"){
      getYearlyAnalyticData("this")
    }else
    if(type==="Weekly"){
      getWeeklyAnalyticData()
    }
    else
    if(type==="Monthly"){
      getMonthAnalyticsData(months);
    }
    else
    if(type==="Last Years"){
      let currentDate = new Date();
      let currentYear = currentDate.getFullYear();
      let lastFiveYears = [];
      for (let i = 1; i <= 5; i++) {
      lastFiveYears.push(currentYear - i);
      }
      setFiveYearsData(lastFiveYears)
      getYearlyAnalyticData("last",lastYear);

    }
    else
    if(type==="Custom Dates"&&startDate&&endDate){
      getCustomDateAnalytics(endDate)
    }
  }
  return (
    <div>
      <div className="row mb-4">
        <div className="col-sm-3">
          <label>Select Category</label>
          <select
            multiple={false}
            style={{
              border: "1px solid",
              borderColor: "#e6e6e6",
              width: "100%",
              padding: "8px",
              borderRadius: "4px",
            }}
            id="val-skill"
            name="val-skill"
            value={category}
            onChange={(event) => {
              setCategory(event.target.value);
              getCategoryChangeWise(event.target.value)
            }}
          >
            {categoryArray.map((val) => {
              return (
                <option style={{ fontSize: "14px" }} value={val}>
                  {val}
                </option>
              );
            })}
          </select>
        </div>
        <div className="col-sm-3">
          <label>Select Type</label>
          <select
            multiple={false}
            style={{
              border: "1px solid",
              borderColor: "#e6e6e6",
              width: "100%",
              padding: "8px",
              borderRadius: "4px",
            }}
            id="val-skill"
            name="val-skill"
            value={type}
            onChange={(event) => {
              setAnalyticData([])
              setType(event.target.value);
              if(event.target.value==="ToDay"){
                getDailyAnalyticData()
              }else
              if(event.target.value==="Yesterday"){
                getYesterdayAnalyticData()
              }else
              if(event.target.value==="Last Month"){
                getLastMonthAnalyticData()
              }else
              if(event.target.value==="This Month"){
                getThisMonthAnalyticData()
              }else
              if(event.target.value==="Yearly"){
                getYearlyAnalyticData("this")
              }else
              if(event.target.value==="Weekly"){
                getWeeklyAnalyticData()
              }
              else
              if(event.target.value==="Monthly"){
                getMonthAnalyticsData("January");
              }
              else
              if(event.target.value==="Last Years"){
                let currentDate = new Date();
                let currentYear = currentDate.getFullYear();
                let lastFiveYears = [];
                for (let i = 1; i <= 5; i++) {
                lastFiveYears.push(currentYear - i);
                }
                setFiveYearsData(lastFiveYears)
                getYearlyAnalyticData("last",lastFiveYears[0]);

              }
            }}
          >
            {typeArray.map((val) => {
              return (
                <option style={{ fontSize: "14px" }} value={val}>
                  {val}
                </option>
              );
            })}
          </select>
        </div>
        {type === "Monthly" && (
          <div className="col-sm-3">
            <label>Select Month</label>
            <select
              multiple={false}
              style={{
                border: "1px solid",
                borderColor: "#e6e6e6",
                width: "100%",
                padding: "8px",
                borderRadius: "4px",
              }}
              id="val-skill"
              name="val-skill"
              value={months}
              onChange={(event) => {
                setMonths(event.target.value);
                getMonthAnalyticsData(event.target.value);
              }}
            >
              {monthArray.map((val) => {
                return (
                  <option style={{ fontSize: "14px" }} value={val}>
                    {val}
                  </option>
                );
              })}
            </select>
          </div>
        )}
         {type === "Last Years" && (
          <div className="col-sm-3">
            <label>Select Year</label>
            <select
              multiple={false}
              style={{
                border: "1px solid",
                borderColor: "#e6e6e6",
                width: "100%",
                padding: "8px",
                borderRadius: "4px",
              }}
              id="val-skill"
              name="val-skill"
              value={lastYear}
              onChange={(event) => {
                setLastYear(event.target.value);
                getYearlyAnalyticData("last",event.target.value);
              }}
            >
              {fiveYearsData.map((val) => {
                return (
                  <option style={{ fontSize: "14px" }} value={val}>
                    {val}
                  </option>
                );
              })}
            </select>
          </div>
        )}
        {type==="Custom Dates"&&(
          <div className="col-sm-3">
             <label>Start Date</label>
               <input
                type="date"
                style={{
                    border: "1px solid",
                    borderColor: "#e6e6e6",
                    width: "100%",
                    padding: "8px",
                    borderRadius: "4px",
                  }}
                id="val-username"
                name="val-username"
                value={startDate}
                max={currentDate}
                onChange={(e) => {
                  setStartDate(e.target.value);
                  let currentDate = new Date(e.target.value);
                  currentDate.setDate(currentDate.getDate() - 1);
                  let formattedCurrentDate = currentDate.toISOString().split('T')[0];
                  setTillDate(formattedCurrentDate)
                }}
              />
          </div>
        )}
         {type==="Custom Dates"&&startDate&&(
          <div className="col-sm-3">
             <label>End Date</label>
              <input
                type="date"
                style={{
                    border: "1px solid",
                    borderColor: "#e6e6e6",
                    width: "100%",
                    padding: "8px",
                    borderRadius: "4px",
                  }}
                id="val-username"
                name="val-username"
                max={tillDate}
                value={endDate}
                onChange={(e) => {
                  setEndDate(e.target.value);
                  getCustomDateAnalytics(e.target.value)
                }}
              />
          </div>
        )}
      </div>
      {spinner?(
         <div className="text-center">
         <Spinner animation="border" variant="primary" />
       </div>
      ):(
        <>
         {analyticData.length !== 0 && (
       <>
        <div className="row">
          <div className="col-sm-3">
            <div
              className="card"
              style={{
                borderRadius: "4px",
                height: "100px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <label className="text-sm">Average Orders Per {(type==="Yearly"||type==="Last Years")?"Month":(type==="ToDay"||type==="Yesterday")?"Hour":"Day"}</label>
              <h4 style={{ color: "black", fontWeight: "600" }}>
                {(type==="Yearly"||type==="Last Years")? analyticData.averageOrderCountPerMonth:(type==="ToDay"||type==="Yesterday")?analyticData.averageOrderCountPerHour:analyticData.averageOrderCountPerDay}
              </h4>
            </div>
          </div>
          <div className="col-sm-3">
            <div
              className="card"
              style={{
                borderRadius: "4px",
                height: "100px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <label className="text-sm">Average Order Amount</label>
              <h4 style={{ color: "black", fontWeight: "600" }}>
                {(type==="Yearly"||type==="Last Years")? analyticData.averageOrderAmountPerMonth:(type==="ToDay"||type==="Yesterday")?analyticData.averageOrderAmountPerHour:analyticData.averageOrderAmountPerDay}
              </h4>
            </div>
          </div>
          <div className="col-sm-3">
            <div
              className="card"
              style={{
                borderRadius: "4px",
                height: "100px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <label className="text-sm">Gross Orders in {(type==="Yearly"||type==="Last Years")?"Year":type==="Weekly"?"a Week":(type==="ToDay"||type==="Yesterday")?"day":type==="Custom Dates"?"":"Month"}</label>
              <h4 style={{ color: "black", fontWeight: "600" }}>
                {analyticData.totalOrderCount}
              </h4>
            </div>
          </div>
          <div className="col-sm-3">
            <div
              className="card"
              style={{
                borderRadius: "4px",
                height: "100px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <label className="text-sm">Gross Orders Amount</label>
              <h4 style={{ color: "black", fontWeight: "600" }}>
                {analyticData.totalOrderAmount}
              </h4>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-3">
            <div
              className="card"
              style={{
                borderRadius: "4px",
                height: "100px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <label className="text-sm">Cancelled order Count</label>
              <h4 style={{ color: "black", fontWeight: "600" }}>
                {analyticData.cancelledOrderCount}
              </h4>
            </div>
          </div>
          <div className="col-sm-3">
            <div
              className="card"
              style={{
                borderRadius: "4px",
                height: "100px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <label className="text-sm">Cancelled Order Amount</label>
              <h4 style={{ color: "black", fontWeight: "600" }}>
                {analyticData.cancelledOrderAmount}
              </h4>
            </div>
          </div>
          <div className="col-sm-3">
            <div
              className="card"
              style={{
                borderRadius: "4px",
                height: "100px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <label className="text-sm">Net Orders Count</label>
              <h4 style={{ color: "black", fontWeight: "600" }}>
                {analyticData.totalOrderCount-analyticData.cancelledOrderCount}
              </h4>
            </div>
          </div>
          <div className="col-sm-3">
            <div
              className="card"
              style={{
                borderRadius: "4px",
                height: "100px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <label className="text-sm">Net Orders Amount</label>
              <h4 style={{ color: "black", fontWeight: "600" }}>
                {analyticData.totalOrderAmount-analyticData.cancelledOrderAmount}
              </h4>
            </div>
          </div>
        </div>
       </>
      )}
      {analyticData.length !== 0 &&type!=="Custom Dates"&& (
        <div
          className="card row"
          style={{
            borderRadius: "4px",
            height: "300px",
          }}
        >
          <div className="col-sm-6 mt-4">
          <BarGraph data={analyticData.chartDetails} from={"Category"} wise={"amount"} />
          </div>
          <div className="col-sm-6 mt-4">
          <BarGraph data={analyticData.chartDetails} from={"Category"} wise={"order"} />
          </div>
         
        </div>
      )}
        </>
      )}
     
    </div>
  );
}
